import React from "react";
import { PrimaryButton, DefaultButton, mergeStyles } from "@fluentui/react/";
import { buttonS } from "../../styles/formBtns.styles";

export interface NewFormBtnsProps {
  cancelForm: any;
  submitBtnText?: string;
  cancelBtnText?: string;
  disabled?: boolean,
  positionAbsolute?: boolean
  disabledOnlySubmitButton?: boolean
}

const btns = mergeStyles({
  position: "absolute",
  bottom: 30,
  left: 40,
});

const NewFormBtns: React.FC<NewFormBtnsProps> = ({
  cancelForm,
  submitBtnText,
  cancelBtnText,
  disabled,
  disabledOnlySubmitButton = false,
  positionAbsolute = false
}) => {
  return (
    <div className={positionAbsolute ? btns : ""}>
      <PrimaryButton
        text={submitBtnText ? submitBtnText : "Zatwierdź"}
        type="submit"
        styles={buttonS}
        disabled={disabled || disabledOnlySubmitButton}
        // form='form'
      />
      <DefaultButton
        text={cancelBtnText ? cancelBtnText : "Anuluj"}
        type="reset"
        onClick={cancelForm}
        disabled={disabled}
      />
    </div>
  );
};

export default NewFormBtns;
